export const DEFAULT_EMBED_VIDEO_URL = 'https://player.vimeo.com/video/605875159?h=1e06f9d73c'

function getYouTubeId(urlObj) {
  const host = urlObj.hostname.replace(/^www\./, '')

  if (host === 'youtu.be') {
    const id = urlObj.pathname.split('/').filter(Boolean)[0]
    return id || ''
  }

  if (host === 'youtube.com' || host === 'm.youtube.com') {
    if (urlObj.pathname === '/watch') {
      return urlObj.searchParams.get('v') || ''
    }

    const parts = urlObj.pathname.split('/').filter(Boolean)
    if (parts[0] === 'embed' || parts[0] === 'shorts' || parts[0] === 'live') {
      return parts[1] || ''
    }
  }

  return ''
}

function getVimeoId(urlObj) {
  const host = urlObj.hostname.replace(/^www\./, '')
  if (host !== 'vimeo.com' && host !== 'player.vimeo.com') return ''

  const segments = urlObj.pathname.split('/').filter(Boolean)
  if (!segments.length) return ''

  if (host === 'player.vimeo.com' && segments[0] === 'video' && /^\d+$/.test(segments[1] || '')) {
    return segments[1]
  }

  const numeric = segments.find((segment) => /^\d+$/.test(segment))
  return numeric || ''
}

export function getVideoEmbedInfo(rawUrl, selectedSource = '') {
  const urlValue = String(rawUrl || '').trim()
  if (!urlValue) {
    return {
      isValid: false,
      provider: '',
      embedUrl: '',
      reason: 'missing-url',
    }
  }

  let parsed
  try {
    parsed = new URL(urlValue)
  } catch {
    return {
      isValid: false,
      provider: '',
      embedUrl: '',
      reason: 'invalid-url',
    }
  }

  const source = String(selectedSource || '').toLowerCase()
  const youtubeId = getYouTubeId(parsed)
  const vimeoId = getVimeoId(parsed)

  if (youtubeId) {
    if (source && source !== 'youtube') {
      return { isValid: false, provider: 'youtube', embedUrl: '', reason: 'source-mismatch' }
    }
    return {
      isValid: true,
      provider: 'youtube',
      embedUrl: `https://www.youtube.com/embed/${youtubeId}`,
      reason: '',
    }
  }

  if (vimeoId) {
    if (source && source !== 'vimeo') {
      return { isValid: false, provider: 'vimeo', embedUrl: '', reason: 'source-mismatch' }
    }

    const hash = parsed.searchParams.get('h')
    const suffix = hash ? `?h=${encodeURIComponent(hash)}` : ''
    return {
      isValid: true,
      provider: 'vimeo',
      embedUrl: `https://player.vimeo.com/video/${vimeoId}${suffix}`,
      reason: '',
    }
  }

  return {
    isValid: false,
    provider: '',
    embedUrl: '',
    reason: 'unsupported-provider',
  }
}
